module.exports = __webpack_public_path__ + "static/media/doc.6592dc0a.svg";